import req from "../../utils/axios"
import BaseAPI from "../baseAPI"

class Regions extends BaseAPI {
  constructor() {
    super()
    // this.uri = "https://api.countrystatecity.in/v1"
  }

  // getAllProvinces = () => {
  //   return req({
  //     useApiKey: true,
  //     url: `${this.uri}/countries/ID/states`,
  //     method: "get"
  //   })
  // }

  // getAllRegencies = (params) => {
  //   return req({
  //     url: `${this.uri}/countries/${params.ciso}/states/${params.siso}/cities`,
  //     method: "get"
  //   })
  // }

  // data from RajaOngkir
  getDomDestinations = (param) => {
    return this.getByQuery("/search-domestic-destinations", param, true)
  }
}

export { Regions as default }